/**
 * Who a FAQ picked for a show, add-on or shop item may be shown or told to
 * (show_faqs / add_on_faqs / shop_item_faqs.visibility). "AI only" keeps a
 * FAQ off the website while the inbox AI still answers with it.
 */
export const FAQ_VISIBILITIES = [
  "visible",
  "ai_only",
  "booked_only",
  "guest_only",
] as const;

export type FaqVisibility = (typeof FAQ_VISIBILITIES)[number];

export const FAQ_VISIBILITY_LABELS: Record<FaqVisibility, string> = {
  visible: "Visible to all",
  ai_only: "AI only",
  booked_only: "Booked customers only",
  guest_only: "Guest only",
};
